import { BrowserRouter } from "react-router-dom";
import { ApiProvider } from "./Components/ApiContext";
import { AppContainer } from "./Components/AppContainer";
import { SnackProvider } from "./Components/SnackContext";
import { UserProvider } from "./Components/UserContext";
import { ScrollToTop } from "./Helpers/ScrollToTop";

export const App = () => (
	<SnackProvider>
		<UserProvider>
			<BrowserRouter>
				<ApiProvider>
					<ScrollToTop />
					<AppContainer />
				</ApiProvider>
			</BrowserRouter>
		</UserProvider>
	</SnackProvider>
);
